import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FResourcePropertyEditorDrawer from './FResourcePropertyEditorDrawer';

interface fResourcePropertyEditor3Props {
  disabledKeys: string[];
  disabledNames: string[];
  defaultData?: {
    key: string;
    name: string;
    description: string;
  } | null;
  noneEditableFields?: Array<'key' | 'name' | 'description'>;
}

type ReturnData = {
  key: string;
  name: string;
  description: string;
} | null;

function fResourcePropertyEditor3({
  disabledKeys,
  disabledNames,
  defaultData,
  noneEditableFields = [],
}: fResourcePropertyEditor3Props): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <FResourcePropertyEditorDrawer
        defaultData={defaultData || null}
        disabledKeys={disabledKeys}
        disabledNames={disabledNames}
        noneEditableFields={noneEditableFields}
        onOk={(obj) => {
          resolve(obj);
        }}
        onClose={() => {
          resolve(null);
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 0.1);
        }}
      />,
    );
  });
}

export default fResourcePropertyEditor3;
